import Backbone from 'backbone'
import userFormOptions from './user-form-options.hbs'
import Members from '../members'
import formHelper from 'scoreboard/components/form-helper'
import config from 'scoreboard/components/config'
import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'
import UserBasicsForm from './user-basics-form'
import user from 'scoreboard/components/user'
import DateInput from 'scoreboard/components/date-input'

var GroupMembers = Members.extend({

	// this.model is the User

	addMessage: function() {
		return i18n.get('admin.user.addGroup')
	},

	drilldownUrl: function(group) {
		return '/admin/groups/' + group.id
	}

})

var UserForm = Backbone.View.extend({

	// this.model is a User

	events: {
		'change [name=locked]' : 'onChangeAccountDisabled'
	},

	initialize: function(options) {
		this.options = options
	},

	render: function(editable) {
		this.userBasicsForm = new UserBasicsForm({
			model: this.model,
			impersonation: user.canImpersonate(this.model.get('id')),
			editable,
			isPanel: true
		})
		this.$el.empty().append(this.userBasicsForm.el)
		this.userBasicsForm.$el.addClass('right-panel')
		this.userBasicsForm.render()

		if (this.model.get('editable') || editable || this.model.isNew()) {
			var ctx = {
				locked : this.model.get('locked'),
				forcePasswordChange: this.model.get('forcePasswordChange') ||
					(config.userPasswordRequired && this.model.isNew())
			}
			this.userBasicsForm.$('.user-profile-advanced').append(userFormOptions(ctx))
		}

		// calendar control for setting date for disabling user account
		this.disableDate = new DateInput({
			el: this.$('.disable-date'),
			initialValue: this.model.get('disableDate')
		}).render()

		// add sections: Member of Groups, Admin of Groups
		this.prepMemberGroups()
		this.prepAdminGroups()
		this.userBasicsForm.$('.panel-content').append(
			this.memberGroups.render().el, this.adminGroups.render().el)

		if (this.model.isNew()) {
			this.$('.right-buttons').hide()
		}

		if (!config.userPasswordVisible) {
			this.$('.user-profile-force-password').remove()
		}
		// #44385 make sure "Disable Account On" date control is disabled if the
		// user's account is disabled
		this.onChangeAccountDisabled()
		this.secure()
		return this
	},

	prepMemberGroups: function() {
		this.memberGroups = new GroupMembers({
			exclude: this.model,
			title: 'admin.user.memberOfGroups',
			noneMessage: i18n.get('admin.user.noGroups'),
			editable: this._groupEditable(),
			members: this.model.get('memberGroups'),
			url: 'api/admin/groups',
			icon: 'profile'
		})
		this.memberGroups.on('change', this.trigger.bind(this, 'change'))
	},

	prepAdminGroups: function() {
		this.adminGroups = new GroupMembers({
			exclude: this.model,
			title: 'admin.user.adminOfGroups',
			noneMessage: i18n.get('admin.user.noGroups.admin'),
			editable: this._groupEditable(),
			members: this.model.get('adminGroups'),
			url: 'api/admin/groups',
			icon: 'profile'
		})
		this.adminGroups.on('change', this.trigger.bind(this, 'change'))
	},

	secure: function() {
		// most security is handled in user-basics-form, but we need to handle
		// removing the ability to delete group members if appropriate (#9224)
		if (!this.model.get('editable')) {
			this.$('.delete-membership').remove()
		}
		// #9550 remove delete icon if local admin does not have permission to modify this group membership
		_.each(this.model.get('memberGroups'), function(member) {
			if (!member.editable) {
				this.$('li[data-id='+member.id +'] .delete-membership').remove()
			}
		}.bind(this))

		// #20510 the public read only user can't change their password
		if (!_.isNil(config.publicReadOnlyUserId) &&
			this.model.id == config.publicReadOnlyUserId) {
			this.$('.user-profile-force-password').remove()
		}
	},

	/**
	 * Indicates whether memberGroups and adminGroups can be modified
	 */
	_groupEditable: function() {
		return this.model.isNew()
			|| this.model.get('groupEditable')
			|| this.model.get('editable')
	},

	readFromDom: function() {
		var user = formHelper.readFromDom(this.el)
		user.memberGroups = this.memberGroups.getMembers()
		user.adminGroups = this.adminGroups.getMembers()
		return user
	},

	onChangeAccountDisabled: function() {
		let checkbox = this.$('[name=locked]')
		let disable = !!checkbox.is(':checked')
		// if an admin changes "User's Account is Disabled" from unchecked to
		// checked, the "Disable Account On" control should be disabled
		this.$('[name=disableDate]').prop('disabled', disable)
	},

	doneSaving: function(e) {
		this.$('.right-buttons').show()
		this.$('.user-label').text(this.model.get('label'))
		// note additional behavior defined in admin-users, since that's where
		// the submit buttons and form tag live
		this.render(true)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.userBasicsForm, this.memberGroups,
			this.adminGroups, this.disableDate], 'remove')
	}

})

export default UserForm

UserForm.__filename__ = 'admin/principals/users/user-form.js'
